import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, Checkbox, Icon } from 'antd';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
const FormItem = Form.Item;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'


class SgiFormCheckbox extends React.Component {

	static defaultProps = {
	};  // 注意这里有分号
	static propTypes = {
	};  // 注意这里有分号

	constructor(props) {
		super(props);

		//初始化state属性
		this.initState();
		// this.state.checked = "";
	}

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
	checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type) {

		//获取需要展示的数据信息
		var moduleDesc = this.props.moduleDesc;
		if (!moduleDesc) {
			return;
		}
		//转换基础属性
		this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
		//转换form公共属性
		AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
		//设置布局
		setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
		//绑定值
		bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops, true);
		//绑定事件
		bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
	}

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
	AddInputAttribute(moduleDesc, formItem, inputprops) {
		//设置默认选中
		var checked = moduleDesc.defVal10;
		if (checked) inputprops.defaultChecked = checked;

		// 是否转义
		this.state.escape = moduleDesc.escape;
	}

	//渲染并返回一个虚拟DOM
	render = function () {

		if (!this.loaded) {
			var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
			//组装属性 初始化属性到this.state
			this.checkbox_mk(parentModule, moduleDesc, bdInst, objFct, type);
			this.loaded = true;
		}

		// 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
		const { _inputProps, _formItemProps } = this.getReviseProps();
		const { isLabel } = _inputProps;

		// 渲染前通用处理，如自定义样式等
		this.renderBeforeReturn();

		let ctl = (isLabel) ?
			<span {...this.state.inputprops} {..._inputProps}>
				<Icon
					type={this.state.inputprops.checked ? "check" : "close"}
					style={{ color: this.state.inputprops.checked ? "#007bff" : "#dc3545" }} />
			</span>
			: <Checkbox {...this.state.inputprops} {..._inputProps} />;

		return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;

	}
}
//给类添加公共方法
Object.assign(SgiFormCheckbox.prototype, sgiFormCtlBaseFun);
//方法特殊  重写setValue方法
SgiFormCheckbox.prototype.setValue = function (value) {
	//更新state
	// if (value && value === this.state.inputprops.value) {
	//     return;
	// }
	let checked = value ? true : false;
	let escape = this.state.escape;
	if (escape) {//转义
		let escs = escape.split("/");
		checked = (value === escs[0]);
	}
	this.state.inputprops.checked = checked;
	this.state.inputprops.value = value;
	//页面校验
	this.validate(value);
}
SgiFormCheckbox.prototype.ctlRefresh = function (attname, bdInst, objFct, value) {
	//对象工厂的值刷新
	this.setBindValue(attname, bdInst, objFct, value);

	//更新state
	let checked = value ? true : false;
	let escape = this.state.escape;
	if (escape) {//转义
		let escs = escape.split("/");
		checked = (value === escs[0]);
	}
	this.state.inputprops.checked = checked;
	//页面校验
	this.validate(value);
}
export { SgiFormCheckbox };
export default SgiFormCheckbox;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormCheckbox.js